export const formatCorrespondent = (name: string, email: string) => `${name} <${email}>`;

export const formatHeaderSubsectionText = (email: string, sentAt: string | undefined) => {
  let text = `Sent to ${email}`;
  if (sentAt) text += ` at ${sentAt}`;
  return text;
};

export const formatDynamicBannerTitle = (email: string) =>
  `The message below may differ from the actual message sent to ${email}`;
